import React, {useState, useEffect} from "react";
import {Form, Search} from "semantic-ui-react";

const KSearch = ({input, label, value, placeHolder, onSearchChange, onResultSelect, meta: {touched, error}, ...rest}) => {


    const [currValue, setCurrValue] = useState(input.value)

    // Reflect external changes to the field value (e.g. prefilling the email
    // from a dropped request file, or from an entitlement lookup) in the box.
    useEffect(() => {
        setCurrValue(input.value)
    }, [input.value])

    const onResult = (e, data) => {
        let value = data.result.title
        setCurrValue(value)
        input.onChange(value)
        onResultSelect(e, data)

    }

    const onSearch = (e, data) => {
        setCurrValue(data.value)
        onSearchChange(e, data)
    }
    const onBlur = (e, data) => {
        input.onBlur(currValue)
    }
    return <React.Fragment>
        <Form.Input {...rest} placeholder={placeHolder} onSearchChange={onSearch}
                    onResultSelect={onResult} onBlur={onBlur}
                    control={Search} label={label} value={currValue}
        />
    </React.Fragment>
}


export default KSearch